"use client";

import { useTranslation } from "@/i18n";
import {
    SectionWrapper,
    SectionEyebrow,
    SectionHeadline,
} from "@/components/ui/SectionWrapper";
import { FadeIn } from "@/components/ui/AnimatedSection";
import { VideoClip } from "@/components/ui/VideoClip";

export function Story() {
    const { t } = useTranslation();
    return (
        <>
            {/* Chapter I - The Collapse */}
            <SectionWrapper id="story" narrow className="py-(--section-y-lg)">
                <FadeIn>
                    <SectionEyebrow>{t.story.chapter1.eyebrow}</SectionEyebrow>
                    <SectionHeadline>{t.story.chapter1.headline}</SectionHeadline>
                </FadeIn>
                <div className="space-y-6 mt-2">
                    {t.story.chapter1.paragraphs.map((p, i) => (
                        <FadeIn key={i} delay={0.1 * (i + 1)}>
                            <p className="text-lg text-text-secondary leading-relaxed">{p}</p>
                        </FadeIn>
                    ))}
                </div>
                <FadeIn delay={0.4}>
                    <div className="divider-mars mt-16 mx-auto w-32" />
                </FadeIn>
            </SectionWrapper>

            {/* Chapter II - The Expeditions */}
            <SectionWrapper narrow className="py-(--section-y-lg)">
                <FadeIn>
                    <SectionEyebrow>{t.story.chapter2.eyebrow}</SectionEyebrow>
                    <SectionHeadline>{t.story.chapter2.headline}</SectionHeadline>
                </FadeIn>
                <div className="space-y-6 mt-2">
                    {t.story.chapter2.paragraphs.map((p, i) => (
                        <FadeIn key={i} delay={0.1 * (i + 1)}>
                            <p className="text-lg text-text-secondary leading-relaxed">{p}</p>
                        </FadeIn>
                    ))}

                    {/* The haunting quote */}
                    <FadeIn delay={0.4}>
                        <blockquote className="relative my-10 py-8 px-8 border-l-2 border-mars bg-surface/50 rounded-r-xl">
                            <p className="text-xl md:text-2xl font-medium text-text italic leading-relaxed">
                                {t.story.chapter2.quote}
                            </p>
                        </blockquote>
                    </FadeIn>

                    <FadeIn delay={0.5}>
                        <p className="text-lg text-text-secondary leading-relaxed">
                            {t.story.chapter2.closing}
                        </p>
                    </FadeIn>
                </div>
                <FadeIn delay={0.6}>
                    <div className="divider-mars mt-16 mx-auto w-32" />
                </FadeIn>
            </SectionWrapper>

            {/* Chapter III - Your Mission (with gas extractor GIF) */}
            <SectionWrapper id="mission" className="py-(--section-y-lg)">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    <div>
                        <FadeIn>
                            <SectionEyebrow>
                                {t.story.chapter3.eyebrow}
                            </SectionEyebrow>
                            <SectionHeadline>
                                {t.story.chapter3.headline}
                            </SectionHeadline>
                            <p className="text-lg text-text-secondary leading-relaxed mb-8">
                                {t.story.chapter3.description}
                            </p>
                        </FadeIn>

                        <FadeIn delay={0.2}>
                            <ul className="space-y-4">
                                {t.story.chapter3.objectives.map((obj, i) => (
                                    <li
                                        key={i}
                                        className="flex items-start gap-3 text-text-secondary"
                                    >
                                        <span className="mt-1.5 w-2 h-2 rounded-full bg-mars shrink-0" />
                                        <span className="text-base leading-relaxed">{obj}</span>
                                    </li>
                                ))}
                            </ul>
                        </FadeIn>
                    </div>

                    <FadeIn delay={0.3}>
                        <div className="rounded-xl overflow-hidden border border-border bg-surface">
                            <VideoClip
                                src="/media/shot_drill.mp4"
                                alt="Gas extraction machinery operating on the Martian surface"
                                className="w-full h-auto block"
                            />
                        </div>
                    </FadeIn>
                </div>
            </SectionWrapper>
        </>
    );
}
